// extracted by mini-css-extract-plugin
export default {"popupCard":"y_b6","imgContainer":"y_b7","buttonContainer":"y_b8","textContainer":"y_b9","secondaryText":"y_cb"};